import { motion } from "framer-motion";
import { Linkedin, ArrowUpRight, Globe, Briefcase } from "lucide-react";
import { Particles } from "../components/Particles";
import { AuroraMesh } from "../components/Graphics";
import { RobotGraphic } from "../components/Robot";

const LINKEDIN = "https://www.linkedin.com/company/zenspark-global-corporation-pvt-ltd";
const WEBSITE = "https://www.zensparkglobal.org";

export default function Follow() {
  return (
    <section
      data-testid="follow-card"
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy px-6 py-16 text-white grain"
    >
      <AuroraMesh />
      <Particles className="absolute inset-0 h-full w-full opacity-60" />

      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-2xl rounded-[28px] border border-white/12 bg-white/[0.04] p-10 text-center backdrop-blur-xl sm:p-14"
      >
        {/* Brand */}
        <div className="flex items-center justify-center gap-3">
          <img src="/brand/mark.png" alt="Zenspark" className="h-11 w-11 rounded-lg object-contain" />
          <span className="font-display text-lg font-bold tracking-tight">Zenspark Global Corporation</span>
        </div>

        {/* Robot accent */}
        <div className="mx-auto mt-8 w-36">
          <RobotGraphic className="w-full" />
        </div>

        {/* Headline */}
        <h1 className="mt-6 text-balance font-display text-4xl font-semibold leading-[1.05] tracking-tighter sm:text-5xl">
          Your trusted<br />
          <span className="text-gradient inline-block" style={{ backgroundImage: "linear-gradient(90deg,#2AA9B8,#5FD0DC,#F5C542)" }}>AI engineering</span> partner.
        </h1>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.3em] text-accent">
          Your Success. Our Passion.
        </p>

        {/* Actions */}
        <div className="mt-10 flex flex-col items-stretch gap-3">
          <a
            href={LINKEDIN}
            target="_blank" rel="noreferrer"
            data-testid="follow-linkedin"
            className="group flex items-center justify-center gap-2.5 rounded-full brand-gradient animate-gradient px-8 py-4 text-base font-semibold text-white brand-glow transition-transform hover:scale-[1.02]"
          >
            <Linkedin className="h-5 w-5" /> Follow us on LinkedIn
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href={WEBSITE}
            target="_blank" rel="noreferrer"
            data-testid="follow-website"
            className="flex items-center justify-center gap-2.5 rounded-full border border-white/20 px-8 py-4 text-base font-semibold text-white transition-colors hover:border-white/60"
          >
            <Globe className="h-5 w-5" /> Visit our website
          </a>
        </div>

        {/* Job seekers */}
        <a
          href={LINKEDIN}
          target="_blank" rel="noreferrer"
          data-testid="follow-jobs"
          className="mt-6 inline-flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-accent"
        >
          <Briefcase className="h-4 w-4" /> Job seeker? Follow us for openings
          <ArrowUpRight className="h-4 w-4" />
        </a>

        <p className="mt-8 font-mono text-[11px] uppercase tracking-widest text-white/40">
          zensparkglobal.org
        </p>
      </motion.div>
    </section>
  );
}
